module.exports = __webpack_public_path__ + "static/media/rambla-logo.42065130.svg";